/**
 * Localized help content, assembled from the per-language × per-page-group
 * files in this folder. Each source page (see PAGE_HELP in ../network-help.data)
 * is translated into French / Persian / Turkish / Russian / Arabic; English is
 * the base and the fallback.
 *
 * The 56 pages are split into 4 groups per language purely to keep the
 * generated files a manageable size — they are merged back into one map per
 * language here. `resolvePageHelp(key, lang)` reads this; anything not present
 * for a language falls back to the English PAGE_HELP entry.
 *
 * Generated by the help-translations workflow. To re-translate a group, rewrite
 * its `help-<lang>-g<n>.ts` file; the merge below picks it up automatically.
 */
import type { PageHelp } from '../network-help.data';

import { L10N_fr_g1 } from './help-fr-g1';
import { L10N_fr_g2 } from './help-fr-g2';
import { L10N_fr_g3 } from './help-fr-g3';
import { L10N_fr_g4 } from './help-fr-g4';
import { L10N_fa_g1 } from './help-fa-g1';
import { L10N_fa_g2 } from './help-fa-g2';
import { L10N_fa_g3 } from './help-fa-g3';
import { L10N_fa_g4 } from './help-fa-g4';
import { L10N_tr_g1 } from './help-tr-g1';
import { L10N_tr_g2 } from './help-tr-g2';
import { L10N_tr_g3 } from './help-tr-g3';
import { L10N_tr_g4 } from './help-tr-g4';
import { L10N_ru_g1 } from './help-ru-g1';
import { L10N_ru_g2 } from './help-ru-g2';
import { L10N_ru_g3 } from './help-ru-g3';
import { L10N_ru_g4 } from './help-ru-g4';
import { L10N_ar_g1 } from './help-ar-g1';
import { L10N_ar_g2 } from './help-ar-g2';
import { L10N_ar_g3 } from './help-ar-g3';
import { L10N_ar_g4 } from './help-ar-g4';

type PageHelpMap = Record<string, PageHelp>;

/** Locale overrides for page help, keyed by language then page key. */
export const PAGE_HELP_L10N: Partial<Record<string, PageHelpMap>> = {
  fr: { ...L10N_fr_g1, ...L10N_fr_g2, ...L10N_fr_g3, ...L10N_fr_g4 },
  fa: { ...L10N_fa_g1, ...L10N_fa_g2, ...L10N_fa_g3, ...L10N_fa_g4 },
  tr: { ...L10N_tr_g1, ...L10N_tr_g2, ...L10N_tr_g3, ...L10N_tr_g4 },
  ru: { ...L10N_ru_g1, ...L10N_ru_g2, ...L10N_ru_g3, ...L10N_ru_g4 },
  ar: { ...L10N_ar_g1, ...L10N_ar_g2, ...L10N_ar_g3, ...L10N_ar_g4 },
};
